import { Component, OnInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../../services/constants"
import swal from "sweetalert2";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: "app-billing-address",
  templateUrl: "./billing-address.component.html",
  styleUrls: ["./billing-address.component.css"]
})
export class BillingAddressComponent implements OnInit {
  allAddress:any=[];
  form: FormGroup;
  allData: any;
  showError = false;
  userData: any;
  countryCode="+1"
  constructor( private formBuilder: FormBuilder, public route: ActivatedRoute,  private router: Router, private api: AdminService, private toastrService: ToastrService,
    private http: HttpClient, private handler: HttpBackend) {
    this.form = this.formBuilder.group({
      firstName: ["",Validators.compose([Validators.required])],
      lastName: ["",Validators.compose([Validators.required])],
      companyName: ["",Validators.compose([Validators.required])],
      countryCode: ["",Validators.compose([Validators.required])],
      phoneNumber: ["",Validators.compose([Validators.required])],
      address: ["",Validators.compose([Validators.required])],
      state: ["",Validators.compose([Validators.required])],
      city: ["",Validators.compose([Validators.required])],
      zipCode: ["",Validators.compose([Validators.required])],
      countryName: ["",Validators.compose([Validators.required])],
    })
   }

  ngOnInit(): void {
    this.userData = localStorage.getItem("userId")
    this.getAddress();
  }

  //getUserDetail
  getUserDetail(){
    this.api.getDatas(apiUrl._getRecuriterDetail+"/"+this.userData)
    .subscribe(async (res) => {
      console.log(res,"stats");
      this.allData = res.data.Recruiter;
      let firstname = "";
      let lastname = "";
      let nameSplit = this.allData.name.split(" ");
      if (nameSplit.length > 1) {
        firstname = nameSplit[0]
        lastname = nameSplit[1]
      } else {
        firstname = this.allData.name
        lastname = ""
      }
      
      this.form.patchValue({
        ...this.allData,
        firstName:firstname,
        lastName:lastname,
        countryName:this.allData.location,
        countryCode:"+1"
      })
    })
  }
  getAddress(){
    this.api.getDatas(apiUrl._billingAddress)
    .subscribe(async (res) => {
      this.allAddress = res.data;
      if(res.data.firstName){
      this.form.patchValue({
        ...this.allAddress,
        countryCode:"+1"
      }) 
    } else{
      this.getUserDetail();
    }
    })
  }
  // submit from
  onSubmit() {
    console.log(this.form.valid,this.form.value)
    if (this.form.valid) {
      this.api.putData(apiUrl._billingAddress, this.removeEmptyFiled(this.form))
        .subscribe(async (res) => {
          this.toastrService.success("Updated Successfully");
          this.getAddress()
        })
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 3000);
    }
  }
  
  //remove

  removeEmptyFiled(form) {
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }
  
  // check if only number
  preventNumbers(event): boolean { 
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
}
